// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class CompanyMatchInfo {
  readonly companyId: string;
  readonly companyName: string;
  readonly matchStrength: string;

  constructor(data: { [key: string]: any } = {}) {
    this.companyId = data.companyId === undefined ? NIL_UUID : data.companyId;
    this.companyName = data.companyName === undefined ? '' : data.companyName;
    this.matchStrength = data.matchStrength === undefined ? '0' : data.matchStrength;
  }

  static zero(): CompanyMatchInfo {
    const zeroValues: ExcludeMethodsDeep<CompanyMatchInfo> = {
      companyId: NIL_UUID,
      companyName: '',
      matchStrength: '0',
    };
    return new CompanyMatchInfo(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompanyMatchInfoWireFormat = {
  companyId: string;
  companyName: string;
  matchStrength: string;
};

type NewCompanyMatchInfoProps = PartialDeep<CompanyMatchInfo, { recurseIntoArrays: true }>;
export const NewCompanyMatchInfo: (props: NewCompanyMatchInfoProps) => CompanyMatchInfo = (props) =>
  new CompanyMatchInfo(props);

type NewCompanyMatchInfoFromWireFormatProps = PartialDeep<
  CompanyMatchInfoWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompanyMatchInfoFromWireFormat: (
  props: NewCompanyMatchInfoFromWireFormatProps,
) => CompanyMatchInfo = (props) => new CompanyMatchInfo(props);
